<div class="modal-header mainColor">
    <h6 class="modal-title" *ngIf="from=='causas'">
        {{"action_plan.plan_development.modal_form.causes_title" | translate}}</h6>
    <h6 class="modal-title" *ngIf="from=='responsable'">
        {{"action_plan.plan_development.modal_form.responsible_title" | translate}}</h6>
    <h6 class="modal-title" *ngIf="from=='corresponsable'">
        {{"action_plan.plan_development.modal_form.coresponsible_title" | translate}}</h6>

    <button type="button" class="close dangerButton" aria-label="Close" style="opacity: 1;" (click)="btnDismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body d-flex justify-content-center" style="min-height: 250px;" ngbAutofocus>
    <div class="col-12" *ngIf="from=='responsable' || from=='corresponsable'">

        <div class="form-row mt-4">
            <div class="col-lg-12">
                <label style="color:#126db3" for="multiselect" *ngIf="from=='responsable'">{{
                    "action_plan.plan_development.modal_form.select_responsible" | translate
                    }}</label>
                <label style="color:#126db3" for="multiselect" *ngIf="from=='corresponsable'">{{
                    "action_plan.plan_development.modal_form.select_coresponsible" | translate
                    }}</label>
                <div class="col-12 form-grey pl-4 py-2" style="min-height: 150px;max-height: 200px;overflow-y: auto;">
                    <ng-container *ngFor="let member of members">
                        <div class="row">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" [(ngModel)]="member.checked">
                                <label class="custom-control-label" for="customCheck1">
                                    {{member.name}}</label>
                            </div>
                        </div>
                    </ng-container>

                </div>

                <!-- <ng-multiselect-dropdown [data]="users" [placeholder]="placeholder" [(ngModel)]="selectedItems"
                    [settings]="dropdownSettings" name="hl" ngDefaultControl (onSelect)="onItemSelect($event)"
                    (onSelectAll)="onSelectAll($event)">
                </ng-multiselect-dropdown> -->
            </div>
        </div>
        <form action="" [formGroup]="membersForm">
            <div class="form-row mt-4" *ngIf="from=='corresponsable'">
                <div class="col-lg-11">

                    <label style="color:#126db3" for="">{{
                        "action_plan.plan_development.modal_form.write_coresponsible" | translate
                        }}</label>
                    <div class="input-group">
                        <input type="text" class="form-control form-grey" formControlName="members" placeholder="" />
                        <div class="input-group-append">
                            <button class="input-group-text label" (click)="add_member()"><i style="color:#126db3"
                                    class="fas fa-plus"></i></button>
                        </div>
                    </div>

                </div>
            </div>
            <div class="form-row mt-4">
                <div class="col-lg-11">
                    <table>
                        <tr *ngFor="let member of members_input; index as i" class="d-flex">
                            <td>
                                {{ member.name}}
                                <a class="ml-2" (click)="delete_member(i)">
                                    <i class="fas fa-trash-alt"></i>
                                </a>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </form>

    </div>
    <div class="col-12" *ngIf="from=='causas'">

        <div class="form-row mt-4">
            <div class="col-lg-11">
                <label style="color:#126db3" for="multiselect">{{
                    "action_plan.plan_development.modal_form.select_cause" | translate
                    }}</label>
                    <div class="col-11 form-grey pl-4 py-2" style="min-height: 150px;max-height: 200px;overflow-y: auto;">
                        <ng-container *ngIf="causesDef.length;else noCauses">
                            <ng-container *ngFor="let cause of causesDef">
                                <div class="row">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" [(ngModel)]="cause.checked">
                                        <label class="custom-control-label" for="customCheck1">
                                            {{cause.titulo}}</label>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                        <ng-template #noCauses>
                            {{
                                "action_plan.plan_development.modal_form.no_causes" | translate
                                }}
                        </ng-template>
                        
                        
                       
    
                    </div>
                <!-- <ng-multiselect-dropdown [data]="causas" [placeholder]="placeholder" [(ngModel)]="selectedCausas"
                    [settings]="dropdownSettings" name="hl" ngDefaultControl (onSelect)="onItemSelect($event)"
                    (onSelectAll)="onSelectAll($event)">
                </ng-multiselect-dropdown> -->
            </div>
        </div>
        <form action="" [formGroup]="causasForm">
            <div class="form-row mt-4">
                <div class="col-lg-11">
                    <label for="coautores" style="color:#126db3">{{
                        "action_plan.plan_development.modal_form.write_cause" | translate
                        }}</label>
                    <div class="input-group">
                        <input type="text" class="form-control form-grey" formControlName="causas" placeholder="" />
                        <div class="input-group-append">
                            <button class="input-group-text label" (click)="add_causas()"><i style="color:#126db3"
                                    class="fas fa-plus"></i></button>
                        </div>
                    </div>

                </div>
            </div>
            <div class="form-row mt-4">
                <div class="col-lg-11">
                    <table>
                        <tr *ngFor="let causas of causas_input; index as i" class="d-flex">
                            <td>
                                {{ causas.name}}
                                <a class="ml-2" (click)="delete_causas(i)">
                                    <i class="fas fa-trash-alt"></i>
                                </a>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </form>

    </div>


</div>
<div class="modal-footer">
    <button class="btn m-2 dangerButton text-white" (click)="btnDismiss()" style="font-size: 14px;">
        {{ "globals.buttons.cancelar" | translate }}
    </button>
    <button class="btn m-2 acceptButton text-white" (click)="btnClose()" style="font-size: 14px;">
        {{ "globals.buttons.save" | translate }}
    </button>
</div>